(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["policy-with-sidebar"] && !Shopify.designMode) return;
  try {
    
  // Add any custom JavaScript if needed
  document.addEventListener('DOMContentLoaded', function () {
    // Handle any client-side functionality
  });

  } catch(e) { console.error(e); }
})();
})();
